import axios from 'axios';
import { getCandidateToken } from './localStroageHandler';

function header(requireAuth = true) {
  let headers = {
    'Content-Type': 'application/json'
  };
  if (requireAuth) headers['Authorization'] = `Bearer ${getCandidateToken()}`;
  return headers;
}

function headercandidate(requireAuth = true) {
  let headers = {
    'Content-Type': 'multipart/form-data',
  };
  if (requireAuth) headers['Authorization'] = `Bearer ${getCandidateToken()}`;
  return headers;
}
export function GetApi(url, auth = true, params = {}) {
  return axios.get(url, { headers: header(auth), params: params });
}
export function PostcandidateApi(url, data, auth = true) {
  return axios.post(url, data, { headers: headercandidate(auth) });
}
export function PostApi(url, data, auth = true) {
  return axios.post(url, data, { headers: header(auth) });
}

export function PatchApi(url, data, auth = true) {
  return axios.patch(url, data, { headers: header(auth) });
}
export function PutApi(url, data, auth = true) {
  return axios.put(url, data, { headers: header(auth) });
}

export function RemoveApi(url, auth = true) {
  return axios.delete(url, { headers: header(auth) });
}